'use client'
import { Grid } from '@chakra-ui/react'
import { VideoCard } from './video-card'
import { useSidebar } from '@/src/store/sidebar-store'

const VidGrid: React.FC<{
  children?: React.ReactNode
  live?: string
  n?: number
  scheduled?: React.ReactNode
}> = ({ children, live, n, scheduled }) => {
  const { isSideBarOpen } = useSidebar()

  return (
    <Grid
      templateColumns={{
        base: '1fr',
        sm: '1fr',
        md: '1fr 1fr',
        lg: '1fr 1fr 1fr',
        xl: '1fr 1fr 1fr 1fr',
        '2xl': isSideBarOpen ? '1fr 1fr 1fr' : '1fr 1fr 1fr 1fr',
        '4xl': isSideBarOpen ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr 1fr',
      }}
      columnGap={4}
      rowGap={4}
      autoFlow="dense"
    >
      {children
        ? children
        : Array(n)
            .fill('-')
            .map((_, i) => (
              <VideoCard
                videoDuration="4:50"
                avatarUrl="https://github.com/dotangad.png"
                creatorName="Angad Singh"
                title="Introduction to invariants"
                timelineUpload="6 days"
                watchTime="2 min"
                scheduled={scheduled}
                live={live}
                creator={true}
                key={i}
              />
            ))}
    </Grid>
  )
}

export default VidGrid
